import React, { useState, useRef, useEffect, useMemo, useCallback, useLayoutEffect } from 'react';
import HasMaskGuideContent from './hasMaskGuideContent';
import useWindowSize from '@web-common/hooks/windowResize';
import ReactDOM from 'react-dom';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { popupIdSelectorNew } from '@web-common/popup_state/selector';
import { PopupActions } from '@web-common/state/reducer';
import { getSiteModule } from 'env_def';
let calcPosTimer = null;
const HasMaskGuide = props => {
    const { enable = true, guideId, step, title, intro, refresh, renderFooter, placement, padding = [0, 0, 0, 0], borderRadius, children, okText, targetWidth, targetHeight, arrowDistance, showSideBar, showArrow, show = true, onStep, onClose, className, hash = '', keyboard, showOrder, } = props;
    const [position, setPosition] = useState();
    const dispatch = useAppDispatch();
    const moduleItem = useMemo(() => getSiteModule(hash), [hash]);
    const popwinId = 'HINT_FOR_SUB_MODULE/' + guideId + onStep;
    const winItem = useAppSelector(state => popupIdSelectorNew(state, popwinId));
    const canShow = (winItem === null || winItem === void 0 ? void 0 : winItem.status) === 'OPEN' && show;
    const [paddingTop, paddingRight, paddingBottom, paddingLeft] = padding;
    const rangestartRef = useRef(null);
    const rangeendRef = useRef(null);
    const range = useMemo(() => {
        if (rangestartRef.current && rangeendRef.current) {
            const range = typeof Range === 'function' ? new Range() : document.createRange();
            range.setStartBefore(rangestartRef.current);
            range.setEndAfter(rangeendRef.current);
            return range;
        }
        return null;
    }, [rangestartRef.current, rangeendRef.current]);
    const offset = useWindowSize(false);
    const calcPos = useCallback(() => {
        if (!canShow || !range) {
            return;
        }
        const triggerRefDom = Array.from(range.commonAncestorContainer.childNodes).slice(range.startOffset + 1, range.endOffset - 1);
        if (triggerRefDom) {
            calcPosTimer = setTimeout(() => {
                let minx = 100000;
                let miny = 100000;
                let maxx = 0;
                let maxy = 0;
                triggerRefDom.forEach((node) => {
                    if (node.nodeType !== 3) {
                        const { x, y, width, height } = node.getBoundingClientRect();
                        if (width > 0 && height > 0) {
                            if (x < minx) {
                                minx = x;
                            }
                            if (y < miny) {
                                miny = y;
                            }
                            if (x + width > maxx) {
                                maxx = x + width;
                            }
                            if (y + height > maxy) {
                                maxy = y + height;
                            }
                        }
                    }
                });
                if (minx !== 100000) {
                    let width = targetWidth ? targetWidth : maxx - minx + paddingLeft + paddingRight;
                    let height = targetHeight ? targetHeight : maxy - miny + paddingTop + paddingBottom;
                    setPosition({
                        x: minx - paddingLeft,
                        y: miny - paddingTop,
                        height: height,
                        width: width,
                    });
                }
            }, 300);
        }
        else {
            setPosition(null);
        }
    }, [canShow, range, refresh, targetWidth, targetHeight, paddingLeft, paddingRight, paddingBottom, paddingTop]);
    useEffect(() => calcPos(), [canShow, range, refresh, offset]);
    useLayoutEffect(() => {
        if (process.env.BUILD_ISEDM && enable) {
            dispatch(PopupActions.registerNewWin({
                type: 'HINT_FOR_SUB_MODULE',
                id: popwinId,
                priority: 100 - onStep - (showOrder !== null && showOrder !== void 0 ? showOrder : 0),
                forModuleId: moduleItem === null || moduleItem === void 0 ? void 0 : moduleItem.key,
            }));
        }
    }, [enable]);
    const Content = useCallback(() => {
        const onCloseInternal = all => {
            const winPrefix = 'HINT_FOR_SUB_MODULE/' + guideId;
            if (all) {
                dispatch(PopupActions.closeWinWithPrefix({ winPrefix, check: true }));
            }
            else {
                dispatch(PopupActions.openOrCloseWin({ winId: popwinId, status: 'CLOSE', check: true }));
                dispatch(PopupActions.openPopWinInOrder(winPrefix));
            }
            onClose && onClose(all);
        };
        const maskProps = {
            show: canShow,
            position,
            showSideBar,
            borderRadius,
            placement,
            showArrow,
            arrowDistance,
            title,
            intro,
            renderFooter,
            guideId,
            step,
            onStep,
            okText,
            onClose: onCloseInternal,
            className,
            keyboard,
        };
        return React.createElement(HasMaskGuideContent, Object.assign({}, maskProps));
    }, [canShow, position, showSideBar, borderRadius, placement, showArrow, arrowDistance, title, intro, renderFooter, guideId, step, onStep, okText, onClose, keyboard]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: rangestartRef, style: { display: 'none' } }),
        children,
        React.createElement("span", { ref: rangeendRef, style: { display: 'none' } }),
        (document === null || document === void 0 ? void 0 : document.body) ? ReactDOM.createPortal(React.createElement(Content, null), document.body) : React.createElement(Content, null)));
};
export default HasMaskGuide;
